import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import SectionTitle from '../../components/SectionTitle';
import SingleTeam from '../../components/Team/SingleTeam';

import shapeImg from '../../assets/img/about/shape-2-1.png';
import teamImg1 from '../../assets/img/team/team-1-1.jpg';
import teamImg2 from '../../assets/img/team/team-1-2.jpg';
import teamImg3 from '../../assets/img/team/team-1-3.jpg';

const Team = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '3',
    spaceBetween: 35,
    autoplay: {
      delay: 3000,
    },
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  };

  return (
    <div
      id="it-team"
      className="it-team-area p-relative fix z-index it-team-style-3 pb-120"
    >
      <div className="it-team-shape-1 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="it-team-title-wrap mb-65">
          <div className="row">
            <div className="col-xl-12">
              <SectionTitle
                itemClass="it-team-title-box text-center"
                subTitleClass="it-section-subtitle green"
                subTitle="Doctor"
                titleClass="it-section-title"
                title="How I Work To improve Hospital"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-team-wrapper">
              <div className="swiper-container it-team-active">
                <Swiper
                  modules={[Autoplay]}
                  {...sliderOption}
                  className="swiper-wrapper"
                >
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg1}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. Keely Evans"
                      specialist="Cardiologist"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg2}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. David Kim"
                      specialist="Gynecologist"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg3}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. Robert Jones"
                      specialist="Gynecologist"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg2}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. David Kim"
                      specialist="Dentist"
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-team-button text-center mt-60">
              <Link to="/team" className="it-btn-theme grey-bg">
                <Button btnText="View All Doctor" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
